import React, { useCallback, useState } from 'react';
import { Anchor, Box, Text } from '@common-fe/common-fe';

import { useDetectTextOverflow } from '@/utils/hooks/useDetectTextOverflow';

interface Props {
  testId?: string;
  icon: React.ReactNode;
  value?: string | React.ReactNode;
  title?: string;
  expandable?: boolean;
  expandButtonText?: string;
}

const AccountsListItemDetails: React.FC<Props> = ({ testId, icon, value, title, expandable, expandButtonText }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const valueRef = React.useRef<HTMLSpanElement>(null);

  const hasTextOverflow = useDetectTextOverflow(valueRef);

  const toggleExpand = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  const showExpandButton = expandable && hasTextOverflow;

  return (
    <Box
      data-testId={`${testId}_item-detail-wrapper`}
      title={title}
      direction="row"
      align="center"
      pad={{ horizontal: 'spacing4', vertical: 'spacing2' }}
      margin={{ top: 'spacing2' }}
    >
      {icon}
      <Text
        data-testId={`${testId}_item-detail-value`}
        ref={valueRef}
        className={isExpanded ? undefined : 'ellipsis-text'}
        margin={{ left: 'spacing4' }}
      >
        {value}
      </Text>
      {showExpandButton && (
        <Anchor
          data-testId={`${testId}_item-detail-expand`}
          onClick={toggleExpand}
          weight={400}
          size="medium"
        >
          {expandButtonText}
        </Anchor>
      )}
    </Box>
  );
};

export default AccountsListItemDetails;
